/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import './kds_fetch_settings';
import './kds_ui_settings';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "kds": {
                            "nested": {
                              "KDSSettings": {
                                "fields": {
                                  "kdsFetch": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.kds.KDSFetchSettings",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "kdsUi": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.kds.KDSUISettings",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.kds?.nested?.KDSSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE KDSSettings @ squareup/devicesettings/profiles/v2/model/settings/kds/kds_settings.proto at 20:1
 */
export const KDSSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.kds.KDSSettings');
fixType(KDSSettings);
Builder.createAndAttachToType(KDSSettings);